import styled from 'styled-components'
import partnersHeader from '../../../images/partners-header.jpg'

export const Wrapper = styled.section`
  background-color: black;
  background-image: url(${partnersHeader});
  background-size: cover;
  background-position: center;
  margin-top: -12rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: calc(100px + 12rem) 20px 100px;
`

export const Title = styled.h2`
  text-transform: capitalize;
  font-weight: 200;
  padding: 0 1rem;
  color: ${props => props.theme.colors.white};
  line-height: 1.25;
  margin-bottom: 0;
`
